export const tool = Object.freeze({
  appointment: 'toolAppointmentApp',
  interestCompare: 'frits_interestCompareTool',
  maxMortgage: 'toolFinalMaxMortgage',
  monthlyExpenses: 'frits_maandlastenTool',
  refinance: 'frits_oversluitenTool',
  increase: 'frits_verhogenTool',
  vriendenhypotheek: 'toolVriendenhypotheek',
});
